import intl from "src/internationalization/intl";
import { Accordion, Grid, Typography } from "src/lib";
import { formatEventDate } from "src/lib/utils/commitmentEvent";
import { ISummaryProps } from "./types";

const Summary = (props: ISummaryProps) => {
    const opportunitiesClientsCount = props.opportunitiesClientsCount ?? 0
    const totalEventsCount = (props.commitment.clients?.length ?? 0) + opportunitiesClientsCount
    return (
        <Accordion.Summary open={props.open} onToggle={props.onToggle}>
            <Grid container justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                    {formatEventDate(props.commitment.due_date)}
                </Typography>
                <Grid>
                    <Grid container gap={1}>
                        <Typography sx={{ fontWeight: 700 }}>
                            {totalEventsCount.toString()}
                        </Typography>
                        <Typography color="quaternary">
                            {totalEventsCount > 1 ? intl("events") : intl("event")}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Accordion.Summary>
    );
};

export { Summary };
